import axios from 'axios';
import { MAINAPIURL } from '../pages/appsettings';
import { tokenService } from '../services/tokenService';

const axiosClient = axios.create({
    baseURL: MAINAPIURL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

axiosClient.interceptors.request.use(
    (config) => {
        const token = tokenService.getAccessToken();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axiosClient.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        if (error.response) {
            // Access Token was expired
            if (error.response.status === 401 && !originalRequest._retry && !originalRequest.url.includes('/user/refresh_token.php')) {
                originalRequest._retry = true;

                try {
                    const response = await axiosClient.post('/user/refresh_token.php');

                    if (response.status === 200 && response.data.access_token) {
                        const { access_token } = response.data;
                        tokenService.setAccessToken(access_token);

                        // Update the header for the original request
                        originalRequest.headers['Authorization'] = `Bearer ${access_token}`;

                        // Retry the original request
                        return axiosClient(originalRequest);
                    }
                } catch (refreshError) {
                    // Refresh token failed (expired or invalid)
                    console.error("Token refresh failed:", refreshError);
                    tokenService.clearAccessToken();
                    localStorage.clear();
                    window.location.href = '/login';
                    return Promise.reject(refreshError);
                }
            }
        }

        return Promise.reject(error);
    }
);

export default axiosClient;
